export const NOO_REGISTRATION_STATUS_PATH = '/noo-registration/status';

export function buildNooRegistrationStatusBusinessUrl(): string {
  return `${NOO_REGISTRATION_STATUS_PATH}/business`;
}

export function buildNooRegistrationStatusOutletUrl(outletId: string): string {
  return `${NOO_REGISTRATION_STATUS_PATH}/outlet/${encodeURIComponent(outletId)}`;
}

export function buildNooRegistrationStatusUrlWithSection(
  sectionId: string
): string {
  return `${NOO_REGISTRATION_STATUS_PATH}?section=${encodeURIComponent(sectionId)}`;
}

/** Matches Chakra `lg` (62em) used by status page responsive layout. */
export const NOO_STATUS_DESKTOP_MEDIA_QUERY = '(min-width: 62em)';

export function buildNooRegistrationStatusSectionDetailHref(section: {
  kind: 'business' | 'documents' | 'outlet';
  outletId?: string;
}): string | undefined {
  if (section.kind === 'business') {
    return buildNooRegistrationStatusBusinessUrl();
  }

  if (section.kind === 'outlet' && section.outletId) {
    return buildNooRegistrationStatusOutletUrl(section.outletId);
  }

  return undefined;
}
